import gql from "graphql-tag";

export const PROJECT_INVITE = gql`
  mutation ($input: projectInviteInput) {
    projectInvite(input: $input) {
      emails
    }
  }
`;
